(function () {
  'use strict';

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency,
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function init(root) {
    if (!root || root.dataset.rmReady === 'true') return;
    root.dataset.rmReady = 'true';
    var category = root.getAttribute('data-rm-category') || 'letters_sans';
    var unit = root.getAttribute('data-rm-unit') || 'letter';
    var unitPlural = root.getAttribute('data-rm-unit-plural') || 'letters';
    var configuratorName = root.getAttribute('data-rm-configurator-name') || 'Modern letters';
    var siteAdapter = window.RustyMigrationAdapter;

    var catalogNode = root.querySelector('[data-rm-letter-catalog]');
    var catalog = [];
    try {
      catalog = JSON.parse((catalogNode && catalogNode.textContent) || '[]');
    } catch (error) {
      catalog = [];
    }

    if (!catalog.length) {
      var adapter = window.RustyMigrationAdapter;
      if (adapter && typeof adapter.list === 'function') {
        var catalogQuery = { category: category, status: 'available', available: true };
        if (category !== 'symbols') catalogQuery.finish = 'rust';
        catalog = adapter.list(catalogQuery)
          .map(function (line) {
            if (!line.glyph && category === 'numbers') {
              var match = String(line.handle || '').match(/(?:^|-)number-([0-9])(?:-|$)/i)
                || String(line.handle || '').match(/^([0-9])-/)
                || String(line.title || '').match(/number\s+([0-9])/i);
              if (match) line = Object.assign({}, line, { glyph: match[1] });
            }
            return line;
          })
          .filter(function (line) { return line.glyph != null && line.size; })
          .map(function (line) {
            return { id: line.variantId, glyph: String(line.glyph), size: String(line.size), finish: line.finish, price: line.priceCents, sku: line.sku, title: line.title, image: line.image };
          });
      }
    }

    // Correct known legacy Shopify metafield drift before resolving previews or
    // cart variants. The Skull & Crossbones product currently reports `cross`
    // as its glyph, which otherwise makes it win the Cross lookup by position.
    if (category === 'symbols') {
      catalog = catalog.map(function (line) {
        var title = String(line && line.title || '').toLowerCase();
        if (title.indexOf('skull') >= 0 && title.indexOf('crossbones') >= 0) {
          return Object.assign({}, line, { glyph: 'skull' });
        }
        return line;
      });
    }

    catalog = catalog.filter(function (line) {
      return line && line.id && line.glyph != null && line.size;
    });

    var finishSelect = root.querySelector('[data-rm-finish]');
    var sizeSelect = root.querySelector('[data-rm-size]');
    var unitPrice = root.querySelector('[data-rm-unit-price]');
    var subtotal = root.querySelector('[data-rm-subtotal]');
    var summary = root.querySelector('[data-rm-selection-summary]');
    var atc = root.querySelector('[data-rm-atc]');
    var atcLabel = root.querySelector('[data-rm-atc-label]');
    var message = root.querySelector('[data-rm-atc-message]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-rm-letter]'));
    var symbolButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rm-symbol-preview]'));
    var activeSymbol = '';

    function finishLabel(finish) {
      return {
        rust: 'Rust',
        pink: 'Pink',
        red: 'Red',
        black: 'Black',
        gloss_white: 'Gloss White'
      }[finish] || finish;
    }

    if (finishSelect && category === 'symbols') {
      var currentFinish = finishSelect.value || 'rust';
      var finishes = catalog.map(function (line) { return String(line.finish || 'rust'); })
        .filter(function (finish, index, values) { return values.indexOf(finish) === index; });
      var finishOrder = ['rust', 'pink', 'red', 'black', 'gloss_white'];
      finishes.sort(function (left, right) { return finishOrder.indexOf(left) - finishOrder.indexOf(right); });
      finishSelect.replaceChildren();
      finishes.forEach(function (finish) {
        var option = document.createElement('option');
        option.value = finish;
        option.textContent = finishLabel(finish);
        finishSelect.appendChild(option);
      });
      if (finishes.indexOf(currentFinish) >= 0) finishSelect.value = currentFinish;
    }

    symbolButtons.forEach(function (button) {
      if (!siteAdapter || typeof siteAdapter.symbolAsset !== 'function') return;
      var asset = siteAdapter.symbolAsset(button.getAttribute('data-rm-symbol-preview'));
      var icon = button.querySelector('[data-rm-symbol-icon]');
      if (asset && asset.icon && icon) icon.src = asset.icon;
    });

    function selectedFinish() {
      return (finishSelect && finishSelect.value) || 'rust';
    }

    function rowsForSize(size) {
      var finish = selectedFinish();
      return catalog.filter(function (line) {
        return String(line.size) === String(size) && String(line.finish || 'rust') === finish;
      });
    }

    function rowFor(size, glyph) {
      return catalog.find(function (line) {
        return String(line.size) === String(size)
          && String(line.finish || 'rust') === selectedFinish()
          && String(line.glyph).toLowerCase() === String(glyph).toLowerCase();
      });
    }

    function firstLineFor(glyph) {
      return catalog.find(function (line) {
        return String(line.finish || 'rust') === selectedFinish()
          && String(line.glyph).toLowerCase() === String(glyph).toLowerCase();
      });
    }

    function syncSymbolRows(size) {
      if (category !== 'symbols') return '';
      var firstVisible = '';
      root.querySelectorAll('[data-rm-symbol-row]').forEach(function (row) {
        var key = row.getAttribute('data-rm-symbol-row') || '';
        var visible = !catalog.length || Boolean(rowFor(size, key));
        row.hidden = !visible;
        if (visible && !firstVisible) firstVisible = key;
        if (!visible) {
          var input = row.querySelector('[data-rm-letter]');
          if (input) input.value = '0';
        }
      });
      return firstVisible;
    }

    function renderSymbolPreview(key) {
      if (category !== 'symbols' || !key) return;
      var line = rowFor(sizeSelect ? sizeSelect.value : '24', key) || firstLineFor(key);
      var asset = siteAdapter && typeof siteAdapter.symbolAsset === 'function' ? siteAdapter.symbolAsset(key) : null;
      var source = (line && line.image) || (asset && asset.preview) || '';
      var button = root.querySelector('[data-rm-symbol-preview="' + key + '"]');
      var tooltip = button && button.querySelector('[role="tooltip"]');
      var label = tooltip ? tooltip.textContent.trim() : key;
      var mainImage = root.querySelector('[data-rm-symbol-main]');
      var galleryTitle = root.querySelector('[data-rm-gallery-title]');
      if (source && mainImage && mainImage.src !== source) mainImage.src = source;
      if (mainImage) mainImage.alt = label + ' marquee symbol';
      if (galleryTitle) galleryTitle.textContent = label;
      symbolButtons.forEach(function (candidate) {
        candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
      });
      showImage(0);
    }

    function selectSymbol(key) {
      if (!key) return;
      var currentSize = sizeSelect ? sizeSelect.value : '24';
      var line = rowFor(currentSize, key) || firstLineFor(key);
      if (line && sizeSelect && !rowFor(currentSize, key)) sizeSelect.value = String(line.size);
      activeSymbol = key;
      refresh();
    }

    function selected() {
      var size = sizeSelect ? sizeSelect.value : '24';
      var picks = [];
      var totalQuantity = 0;
      var totalCents = 0;
      inputs.forEach(function (input) {
        var quantity = Math.max(0, Math.min(99, Number(input.value) || 0));
        input.value = String(quantity);
        var field = input.closest('[data-rm-quantity-field]');
        if (field) field.classList.toggle('is-active', quantity > 0);
        if (!quantity) return;
        var glyph = String(input.getAttribute('data-rm-letter') || '');
        var line = rowFor(size, glyph);
        picks.push({ glyph: glyph, quantity: quantity, line: line || null });
        totalQuantity += quantity;
        if (line) totalCents += Number(line.price || 0) * quantity;
      });
      return { size: size, picks: picks, totalQuantity: totalQuantity, totalCents: totalCents };
    }

    function setMessage(text, success) {
      if (!message) return;
      message.textContent = text || '';
      message.hidden = !text;
      message.style.color = success ? 'var(--rm-ink-soft)' : 'var(--rm-rust)';
    }

    function refresh() {
      if (sizeSelect) {
        Array.prototype.slice.call(sizeSelect.options).forEach(function (option) {
          option.disabled = catalog.length > 0 && rowsForSize(option.value).length === 0;
        });
        if (sizeSelect.selectedOptions[0] && sizeSelect.selectedOptions[0].disabled) {
          var availableSize = Array.prototype.slice.call(sizeSelect.options).find(function (option) { return !option.disabled; });
          if (availableSize) sizeSelect.value = availableSize.value;
        }
      }
      var size = sizeSelect ? sizeSelect.value : '24';
      var rows = rowsForSize(size);
      var basePrice = rows.length ? Number(rows[0].price || 0) : 0;
      if (unitPrice) unitPrice.textContent = money(basePrice);
      root.querySelectorAll('[data-rm-detail-size]').forEach(function (node) { node.textContent = size; });
      var depth = unit === 'letter' && Number(size) <= 12 ? '3' : '4';
      root.querySelectorAll('[data-rm-detail-depth]').forEach(function (node) { node.textContent = depth; });
      root.querySelectorAll('[data-rm-detail-finish]').forEach(function (node) {
        node.textContent = finishLabel(selectedFinish()) + ' Finish';
      });
      var gallerySizeIcon = root.querySelector('[data-rm-gallery-size-icon]');
      if (gallerySizeIcon) {
        var migrationAdapter = window.RustyMigrationAdapter;
        if (migrationAdapter && typeof migrationAdapter.setMappedAsset === 'function') {
          migrationAdapter.setMappedAsset(gallerySizeIcon, size);
        }
        gallerySizeIcon.alt = size + ' inch size';
      }

      if (category === 'symbols') {
        var firstVisibleSymbol = syncSymbolRows(size);
        if (!activeSymbol || (catalog.length && !rowFor(size, activeSymbol))) activeSymbol = firstVisibleSymbol;
        renderSymbolPreview(activeSymbol);
      }

      var state = selected();
      if (subtotal) subtotal.textContent = money(state.totalCents);
      if (summary) {
        if (!state.totalQuantity) {
          summary.hidden = true;
          summary.textContent = '';
        } else {
          summary.hidden = false;
          summary.textContent = state.totalQuantity + ' ' + (state.totalQuantity === 1 ? unit : unitPlural) + ': ' + state.picks.map(function (pick) {
            return pick.quantity > 1 ? pick.glyph + '×' + pick.quantity : pick.glyph;
          }).join(' ');
        }
      }

      var missing = state.picks.filter(function (pick) { return !pick.line; });
      var canAdd = catalog.length > 0 && state.totalQuantity > 0 && missing.length === 0;
      if (atc) atc.disabled = !canAdd;
      if (atcLabel) {
        if (!catalog.length) atcLabel.textContent = 'Catalog unavailable';
        else if (!state.totalQuantity) atcLabel.textContent = 'Select your ' + unitPlural;
        else if (missing.length) atcLabel.textContent = 'Selection unavailable';
        else atcLabel.textContent = 'Add to cart';
      }
      if (missing.length) setMessage('This size is unavailable for: ' + missing.map(function (pick) { return pick.glyph; }).join(', ') + '.');
      else if (message && !message.dataset.rmBusy) setMessage('');
    }

    if (sizeSelect) sizeSelect.addEventListener('change', refresh);
    if (finishSelect) finishSelect.addEventListener('change', refresh);

    inputs.forEach(function (input) { input.addEventListener('input', refresh); });
    root.querySelectorAll('[data-rm-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var glyph = button.getAttribute('data-rm-for');
        var input = root.querySelector('[data-rm-letter="' + glyph + '"]');
        if (!input) return;
        var change = button.getAttribute('data-rm-step') === 'down' ? -1 : 1;
        input.value = String(Math.max(0, Math.min(99, (Number(input.value) || 0) + change)));
        refresh();
      });
    });

    if (category === 'symbols') {
      var requestedSymbol = new URLSearchParams(window.location.search).get('symbol');
      if (requestedSymbol) {
        var requestedLine = rowFor(sizeSelect ? sizeSelect.value : '24', requestedSymbol) || firstLineFor(requestedSymbol);
        if (requestedLine && sizeSelect) sizeSelect.value = String(requestedLine.size);
        if (requestedLine) activeSymbol = requestedSymbol.toLowerCase();
      }
    }

    if (atc) {
      atc.addEventListener('click', function () {
        if (atc.disabled) return;
        var state = selected();
        var items = state.picks.map(function (pick) {
          return {
            id: Number(pick.line.id),
            quantity: pick.quantity,
            properties: {
              '_Rusty Marquee configurator': configuratorName,
              'Selection': pick.glyph,
              'Size': state.size + '"',
              'Finish': finishLabel(selectedFinish())
            }
          };
        });
        atc.disabled = true;
        atc.dataset.rmBusy = 'true';
        if (atcLabel) atcLabel.textContent = 'Adding…';
        setMessage('');
        var cartApi = window.rmShopifyCart;
        var request = cartApi && typeof cartApi.addItems === 'function'
          ? cartApi.addItems(items)
          : Promise.reject(new Error('Cart is still loading.'));
        request.then(function () {
          setMessage('Added to your cart.', true);
        }).catch(function (error) {
          setMessage((error && error.message) || 'Could not add to cart. Please try again.');
        }).finally(function () {
          delete atc.dataset.rmBusy;
          refresh();
        });
      });
    }

    var images = Array.prototype.slice.call(root.querySelectorAll('[data-rm-gallery-image]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-rm-thumb]'));
    var activeImage = 0;

    function updateGalleryLabelContrast(image) {
      var galleryLabel = root.querySelector('[data-rm-gallery-label]');
      if (!galleryLabel) return;
      if (category !== 'symbols') {
        galleryLabel.classList.toggle('is-dark', activeImage === 0);
        return;
      }

      function sampleImage() {
        if (!image || !image.naturalWidth || !image.naturalHeight) return;
        try {
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d', { willReadFrequently: true });
          if (!context) return;
          canvas.width = 32;
          canvas.height = 32;
          var sampleX = Math.floor(image.naturalWidth * 0.72);
          var sampleWidth = Math.max(1, image.naturalWidth - sampleX);
          var sampleHeight = Math.max(1, Math.floor(image.naturalHeight * 0.28));
          context.drawImage(image, sampleX, 0, sampleWidth, sampleHeight, 0, 0, canvas.width, canvas.height);
          var pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
          var luminance = 0;
          for (var pixel = 0; pixel < pixels.length; pixel += 4) {
            luminance += (0.2126 * pixels[pixel]) + (0.7152 * pixels[pixel + 1]) + (0.0722 * pixels[pixel + 2]);
          }
          luminance /= pixels.length / 4;
          galleryLabel.classList.toggle('is-dark', luminance >= 160);
        } catch (error) {
          galleryLabel.classList.remove('is-dark');
        }
      }

      if (image && image.complete) sampleImage();
      else if (image) image.addEventListener('load', sampleImage, { once: true });
    }

    function showImage(index) {
      if (!images.length) return;
      activeImage = (index + images.length) % images.length;
      images.forEach(function (image, imageIndex) { image.classList.toggle('is-active', imageIndex === activeImage); });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === activeImage;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      updateGalleryLabelContrast(images[activeImage]);
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showImage(Number(thumb.getAttribute('data-rm-thumb')) || 0); });
    });
    symbolButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectSymbol(button.getAttribute('data-rm-symbol-preview') || '');
      });
    });
    var previous = root.querySelector('[data-rm-gallery-previous]');
    var next = root.querySelector('[data-rm-gallery-next]');
    if (previous) previous.addEventListener('click', function () { showImage(activeImage - 1); });
    if (next) next.addEventListener('click', function () { showImage(activeImage + 1); });

    function wireModal(openSelector, modalSelector) {
      var openButton = root.querySelector(openSelector);
      var modal = root.querySelector(modalSelector);
      if (!openButton || !modal) return;
      function close() { modal.hidden = true; document.body.style.overflow = ''; }
      openButton.addEventListener('click', function () { modal.hidden = false; document.body.style.overflow = 'hidden'; });
      modal.querySelectorAll('[data-rm-close-modal]').forEach(function (button) { button.addEventListener('click', close); });
      modal.addEventListener('click', function (event) { if (event.target === modal) close(); });
    }
    wireModal('[data-rm-open-size]', '[data-rm-size-modal]');
    wireModal('[data-rm-open-bulbs]', '[data-rm-bulb-modal]');

    if (!catalog.length) setMessage('The Shopify ' + unit + ' catalog did not expose any matching variants.');
    refresh();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rm-letter-config]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
